/*会员中心接口*/ 
import { axios } from '@/utils/http'
//通用上传接口
export const uploadCommon = (params) => axios({
  method: 'POST',
  data: {
    ...params
  },
  contentType: 'formData',
  payHeader:true
}, '/user-api/common/upload')

//修改邮箱
export const updateEmail = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
  payHeader:true
}, '/user-api/user/updateEmail?'+params)

//修改邮箱
export const updatePhone = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
  payHeader:true
}, '/user-api/user/updatePhone?'+params)

//邮箱验证码验证
export const verifyEmailCode = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
  payHeader:true
}, '/user-api/user/verifyEmailCode?'+params)

//获取用户信息
export const getUserInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/user/getUserInfo')

//获取服务主体树形结构
export const getPrincipalTree = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/getPrincipalTree')

//获取专业承包企业资质等级树形结构
export const getQualificationGradeTree = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/getQualificationGradeTree')

//获取总承包企业资质类型树形结构
export const getQualificationTree = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/getQualificationTree')

//获取分类字典
export const queryCategoryByCode = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/queryCategoryByCode?'+params)

//获取数据字典
export const queryDictItemsByCode = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/queryDictItemsByCode?'+params)

//头像更新
export const avatarChange = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/user/avatarChange?'+params)

//获取上报信息
export const getReportInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/report/getReportInfo')

//基本信息保存
export const saveBasic = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/report/saveBasic')

//联系信息保存
export const saveContact = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/report/saveContact')

//入会申请表保存
export const saveApplicationFile = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/report/saveApplicationFile')

//营业执照保存
export const saveLicenseFile = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/report/saveLicenseFile')

//个人上报
export const personCompleteSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/report/personCompleteSubmit')

//单位上报
export const unitCompleteSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/report/unitCompleteSubmit')

//获取缴费记录
export const addSiteUserPayment = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/report/addSiteUserPayment?'+params)

//修改密码
export const passwordChange = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/user/passwordChange?'+params)

//修改手机或邮箱密码验证
export const yzLogin = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/user/login?'+params)

//消息中心
export const getMyMessage = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/message/getMyMessage?'+params)

//产品收藏
export const collectProducts = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/collect/products?'+params)

//产品收藏取消
export const collectCancel = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/collect/cancel?'+params)

//投诉建议保存
export const suggestSave = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/suggest/save')

//手机验证码校验
export const phoneCodeCheck = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
}, '/phoneCodeCheck?'+params)

//供需列表
export const supplyDemandList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/supply-demand/list?'+params)

//供需列表通过id查询
export const supplyDemandQuery = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/supply-demand/queryById?'+params)

//供需发布/撤销
export const supplyUpdatePublic = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/supply-demand/updatePublic?'+params)

//供需编辑
export const supplyDemandEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/supply-demand/edit')

//供需添加
export const supplyDemandAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/supply-demand/add')


//招聘列表
export const recruitList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/recruitment/list?'+params)

//招聘列表通过id查询
export const recruitQuery = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/recruitment/queryById?'+params)

//招聘发布/撤销
export const recruitUpdatePublic = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/recruitment/updatePublic?'+params)

//招聘编辑
export const recruitEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/recruitment/edit')

//招聘添加
export const recruitAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/recruitment/add')


//获取会员权益
export const getMemberEquity = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/getMemberEquity')

export const getHeader = () => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/getHeader')

export const getFooter = () => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/getFooter')

//完善资料 （第一版）
export const baseInfoChange = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/user/baseInfoChange')

//提交认证 个人 （第二版）
export const certificationSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/user/certificationSubmit')

//提交认证 企业 （第二版）
export const enterprisSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/user/enterpriseCertificationSubmit')

//绑定-解绑三方账号  
export const bindingThirdAccount = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
  payHeader:true
}, '/user-api/user/bindingThirdAccount'+params)

//生成第三方绑定认证地址
export const getBindRender = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
  payHeader:true
}, '/user-api/user/render')

//获取站点头部底部信息
export const getBaseInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/commonInfo/getBaseInfo')

//获取完善资料表单结构  type为表单类型:member_info个人信息
export const getCustomForm = (type,id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
}, '/commonInfo/getFormStructure?type='+type+'&category='+id)

//获取自定义表单结构  type为表单类型:other自定义
export const getFreeForm = (type,id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
}, '/commonInfo/getFormStructure?type='+type+'&code='+id)

//获取自定义表单用户提交信息渲染前端表单
export const getCustomFormInfo = (formId) => axios({
  method: 'POST',
  contentType: 'json',
  payHeader:true
}, '/user-api/common/getFormDataByUserAndFormId?formId='+formId)

//自定义表单内容提交
export const subCustomForm = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/common/submitFormData')

//获取树形字典
export const queryTreeCategoryByCode = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/common/queryTreeCategoryByCode?'+params)


// WEBPACK FOOTER //
// ./src/api/person/person.js